import React, { useEffect, useState } from 'react';
import { isLiveSite } from '../utils/liveSite';
import './PreviewFormNotice.css';

/**
 * Forms only send on the live site (clinicalminds.net, www, monivae).
 * Anywhere else (PR previews, local builds) they show a note and do not submit,
 * because previews would otherwise send to the LIVE Function App.
 *
 * Decided after the page loads (useEffect), so the pre-rendered HTML never
 * contains the note and the live site hydrates cleanly.
 */
export function useFormsSwitchedOff() {
  const [off, setOff] = useState(false);
  useEffect(() => {
    // Never during pre-rendering, so the saved HTML is the same as the live page
    if (window.__PRERENDERING__) return;
    setOff(!isLiveSite());
  }, []);
  return off;
}

export function PreviewFormNotice() {
  return (
    <div className="preview-form-notice" role="status" data-testid="preview-form-notice">
      <strong>Preview: this form is switched off.</strong> It only sends on the live site, clinicalminds.net.
    </div>
  );
}
